<template>
	<client-page>
        <v-container>
            인터뷰상세페이지
            <v-card-title>{{interview.subject}}</v-card-title>
            <v-img :src="interview.thumb"></v-img>
            <v-card-text v-html="interview.content"></v-card-text>
        </v-container>
	</client-page>
</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import api from '@/api';

export default {
	components: {
        ClientPage,
    },
    data() {
        return {
            interview: '',
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            let { board } = await api.v1.boards.get({ _id: this.$route.params._interview  });
            this.interview = board;
        }
    }
}
</script>
